import * as React from 'react'
import styled from 'styled-components'
import { Button } from '../atoms/Button'
import { Content } from '../atoms/Content/index'
import { Input } from '../atoms/Input'
import { Layout } from '../atoms/Layout'
import { Link } from '../atoms/Link'
import { Nav } from '../atoms/Nav'
import { P } from '../atoms/P'
import { media } from '../utils/media'
import {Success} from '../atoms/Success'
import {Select} from '../atoms/Select'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

export const EmailSentPage = () => (
  <Layout>
    <Nav.Bar>
      <Nav.HomeButtonWeb />
    </Nav.Bar>
    <Content style={{ textAlign: 'center' }}>
      <Success/>
      <H1>{lang === 'es' ? 'Enlace enviado con éxito' : 'Link sent successfully'}</H1>
      <P>{lang === 'es' ? 'consultar su correo electrónico' : 'Check your email'}</P>
      <Link to="/login" style={{ marginTop: 50 }}>{lang === 'es' ? 'atrás para iniciar sesión' : 'Back to Login'}</Link>
    </Content>
  </Layout>
)

const H1 = styled.h1`

  font-family: Nunito;
  font-size: 24px;
  font-weight: 900;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/EmailSentPage.tsx